// import React, { useState } from 'react';
// import { useArticles } from '../contexts/ArticleContext';
// import { useNavigate } from 'react-router-dom';
// import './WriteArticle.css';

// const WriteArticle = () => {
//   const { publishArticle } = useArticles();
//   const navigate = useNavigate();
  
//   const [article, setArticle] = useState({
//     title: '',
//     author: 'zxj',
//     excerpt: '',
//     content: '',
//     tags: '',
//     category: '前端'
//   });

//   const [previewMode, setPreviewMode] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [message, setMessage] = useState('');

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setArticle(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     // 验证必填字段
//     if (!article.title.trim()) {
//       setMessage('请填写文章标题');
//       return;
//     }
    
//     if (!article.excerpt.trim()) {
//       setMessage('请填写文章摘要');
//       return;
//     }
    
//     if (!article.content.trim()) {
//       setMessage('请填写文章内容');
//       return;
//     }

//     setIsSubmitting(true);
//     setMessage('正在发布文章...');

//     try {
//       // 调用发布文章函数
//       const newArticle = await publishArticle(article);
      
//       setMessage('文章发布成功！正在跳转到首页...');
      
//       // 清空表单
//       setArticle({
//         title: '',
//         author: 'zxj',
//         excerpt: '',
//         content: '',
//         tags: '',
//         category: '前端'
//       });

//       // 3秒后跳转到首页
//       setTimeout(() => {
//         navigate('/');
//       }, 3000);

//     } catch (error) {
//       setMessage('发布失败，请重试');
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const formatDate = () => {
//     const now = new Date();
//     return now.toLocaleDateString('zh-CN', {
//       year: 'numeric',
//       month: '2-digit',
//       day: '2-digit'
//     });
//   };

//   return (
//     <div className="write-article">
//       <div className="write-header">
//         <h1>撰写新文章</h1>
//         <div className="write-subtitle">
//           <span className="current-date">当前日期: {formatDate()}</span>
//           <span className="article-count">今天还可以发布文章</span>
//         </div>
//       </div>
      
//       {message && (
//         <div className={`message ${message.includes('成功') ? 'success' : 'error'}`}>
//           {message}
//         </div>
//       )}
      
//       <div className="write-controls">
//         <button 
//           className={`control-btn ${!previewMode ? 'active' : ''}`}
//           onClick={() => setPreviewMode(false)}
//         >
//           编辑模式
//         </button>
//         <button 
//           className={`control-btn ${previewMode ? 'active' : ''}`}
//           onClick={() => setPreviewMode(true)}
//         >
//           预览模式
//         </button>
//         <button 
//           className="save-btn" 
//           onClick={() => alert('已保存到草稿箱')}
//         >
//           保存草稿
//         </button>
//         <button 
//           className="publish-btn"
//           onClick={handleSubmit}
//           disabled={isSubmitting}
//         >
//           {isSubmitting ? '发布中...' : '发布文章'}
//         </button>
//       </div>
      
//       {!previewMode ? (
//         <form className="article-form" onSubmit={handleSubmit}>
//           <div className="form-section">
//             <h3>文章标题</h3>
//             <div className="form-hint">
//               <span className="hint-item">编辑人：{article.author}</span>
//               <span className="hint-item">上次编辑：{formatDate()}</span>
//             </div>
//             <input
//               type="text"
//               name="title"
//               value={article.title}
//               onChange={handleChange}
//               placeholder="请输入文章标题"
//               className="form-input title-input"
//               required
//             />
//           </div>
          
//           <div className="form-section">
//             <h3>文章摘要</h3>
//             <div className="form-hint">
//               <span className="hint-item">编辑人：{article.author}</span>
//               <span className="hint-item">建议字数：100-200字</span>
//             </div>
//             <textarea
//               name="excerpt"
//               value={article.excerpt}
//               onChange={handleChange}
//               placeholder="请输入文章摘要，用于在列表页显示"
//               className="form-textarea excerpt-textarea"
//               rows="3"
//               required
//             />
//           </div>
          
//           <div className="form-section">
//             <h3>插入文章内容</h3>
//             <div className="form-hint">
//               <span className="hint-item">请使用Markdown格式输入文章内容</span>
//               <span className="hint-item">支持：标题、列表、代码块、链接等</span>
//             </div>
//             <div className="editor-tools">
//               <button type="button" className="tool-btn">插入标题</button>
//               <button type="button" className="tool-btn">插入代码块</button>
//               <button type="button" className="tool-btn">插入链接</button>
//               <button type="button" className="tool-btn">插入图片</button>
//               <button type="button" className="tool-btn">插入列表</button>
//             </div>
//             <textarea
//               name="content"
//               value={article.content}
//               onChange={handleChange}
//               placeholder="请在此处输入文章内容（支持Markdown语法）..."
//               className="form-textarea content-textarea"
//               rows="15"
//               required
//             />
//           </div>
          
//           <div className="form-section">
//             <h3>文章标签</h3>
//             <input
//               type="text"
//               name="tags"
//               value={article.tags}
//               onChange={handleChange}
//               placeholder="请输入标签，用逗号分隔（例如：React,JavaScript,前端）"
//               className="form-input tags-input"
//             />
//           </div>
          
//           <div className="form-section">
//             <h3>文章信息</h3>
//             <div className="info-grid">
//               <div className="info-item">
//                 <label>作者</label>
//                 <input
//                   type="text"
//                   name="author"
//                   value={article.author}
//                   onChange={handleChange}
//                   placeholder="pigStar"
//                   className="form-input"
//                 />
//               </div>
//               <div className="info-item">
//                 <label>分类</label>
//                 <select 
//                   name="category"
//                   value={article.category}
//                   onChange={handleChange}
//                   className="form-select"
//                 >
//                   <option value="前端">前端</option>
//                   <option value="后端">后端</option>
//                   <option value="JavaScript">JavaScript</option>
//                   <option value="React">React</option>
//                   <option value="Node.js">Node.js</option>
//                   <option value="TypeScript">TypeScript</option>
//                   <option value="其他">其他</option>
//                 </select>
//               </div>
//             </div>
//           </div>
//         </form>
//       ) : (
//         <div className="article-preview">
//           <div className="preview-header">
//             <h2>{article.title || '文章标题预览'}</h2>
//             <div className="preview-meta">
//               <span className="preview-author">作者：{article.author}</span>
//               <span className="preview-date">发布日期：{formatDate()}</span>
//             </div>
//           </div>
          
//           <div className="preview-content">
//             <div className="preview-excerpt">
//               <h4>文章摘要</h4>
//               <p>{article.excerpt || '文章摘要预览内容...'}</p>
//             </div>
            
//             <div className="preview-body">
//               <h4>文章内容</h4>
//               <div className="markdown-preview">
//                 {article.content || '文章内容预览...\n\n## 二级标题\n\n这里是文章内容。\n\n```javascript\nconsole.log("Hello World");\n```\n\n- 列表项1\n- 列表项2\n- 列表项3'}
//               </div>
//             </div>
            
//             <div className="preview-tags">
//               <h4>文章标签</h4>
//               <div className="tags-container">
//                 {article.tags ? article.tags.split(',').map(tag => tag.trim()).filter(tag => tag).map(tag => (
//                   <span key={tag} className="preview-tag">{tag}</span>
//                 )) : <span className="preview-tag">示例标签</span>}
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default WriteArticle;
import React, { useState, useEffect } from 'react';
import { useArticles } from '../contexts/ArticleContext';
import { useNavigate, useParams } from 'react-router-dom';
import './WriteArticle.css';

const WriteArticle = () => {
  const { publishArticle, updateArticle, getArticleById } = useArticles();
  const navigate = useNavigate();
  const { id } = useParams();
  
  const isEditing = !!id;
  const currentArticle = isEditing ? getArticleById(parseInt(id)) : null;
  
  const [article, setArticle] = useState({
    title: '',
    author: 'zxj',
    excerpt: '',
    content: '',
    tags: '',
    category: '前端'
  });

  const [previewMode, setPreviewMode] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState('');

  // 如果是编辑模式，加载文章数据
  useEffect(() => {
    if (isEditing && currentArticle) {
      setArticle({
        title: currentArticle.title || '',
        author: currentArticle.author || 'zxj',
        excerpt: currentArticle.excerpt || '',
        content: currentArticle.content || '',
        tags: currentArticle.tags ? currentArticle.tags.join(',') : '',
        category: currentArticle.category || '前端'
      });
    }
  }, [isEditing, currentArticle]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setArticle(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // 验证必填字段
    if (!article.title.trim()) {
      setMessage('请填写文章标题');
      return;
    }
    
    if (!article.excerpt.trim()) {
      setMessage('请填写文章摘要');
      return;
    }
    
    if (!article.content.trim()) {
      setMessage('请填写文章内容');
      return;
    }

    setIsSubmitting(true);
    setMessage(isEditing ? '正在更新文章...' : '正在发布文章...');

    try {
      if (isEditing) {
        // 更新文章
        await updateArticle(parseInt(id), {
          ...article,
          tags: article.tags ? article.tags.split(',').map(tag => tag.trim()).filter(tag => tag) : ['未分类']
        });
        
        setMessage('文章更新成功！正在跳转到文章详情...');
        
        // 3秒后跳转到文章详情页
        setTimeout(() => {
          navigate(`/post/${id}`);
        }, 3000);
      } else {
        // 发布新文章
        const newArticle = await publishArticle(article);
        
        setMessage('文章发布成功！正在跳转到首页...');
        
        // 清空表单
        setArticle({
          title: '',
          author: 'zxj',
          excerpt: '',
          content: '',
          tags: '',
          category: '前端'
        });

        // 3秒后跳转到首页
        setTimeout(() => {
          navigate('/');
        }, 3000);
      }

    } catch (error) {
      setMessage(isEditing ? '更新失败，请重试' : '发布失败，请重试');
    } finally {
      setIsSubmitting(false);
    }
  };

  const formatDate = () => {
    const now = new Date();
    return now.toLocaleDateString('zh-CN', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
  };

  const handleInsert = (type) => {
    let insertText = '';
    let cursorPosition = 0;

    switch (type) {
      case '标题':
        insertText = '# 这是标题\n\n';
        cursorPosition = 1;
        break;
      case '代码块':
        insertText = '```javascript\n// 在这里写代码\nconsole.log("Hello World");\n```\n\n';
        cursorPosition = 14;
        break;
      case '链接':
        insertText = '[链接文字](https://example.com)';
        cursorPosition = 1;
        break;
      case '图片':
        insertText = '![图片描述](https://via.placeholder.com/400x200)';
        cursorPosition = 3;
        break;
      case '列表':
        insertText = '- 列表项1\n- 列表项2\n- 列表项3\n\n';
        cursorPosition = 2;
        break;
      default:
        return;
    }

    const textarea = document.querySelector('.content-textarea');
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    
    const newText = text.substring(0, start) + insertText + text.substring(end);
    setArticle(prev => ({
      ...prev,
      content: newText
    }));

    // 将焦点设置回文本框并定位光标
    setTimeout(() => {
      textarea.focus();
      textarea.setSelectionRange(start + cursorPosition, start + cursorPosition);
    }, 0);
  };

  return (
    <div className="write-article">
      <div className="write-header">
        <h1>{isEditing ? '编辑文章' : '撰写新文章'}</h1>
        <div className="write-subtitle">
          <span className="current-date">当前日期: {formatDate()}</span>
          <span className="article-count">已发布文章: {currentArticle ? '编辑中' : '新文章'}</span>
        </div>
      </div>
      
      {message && (
        <div className={`message ${message.includes('成功') ? 'success' : 'error'}`}>
          {message}
        </div>
      )}
      
      <div className="write-controls">
        <button 
          className={`control-btn ${!previewMode ? 'active' : ''}`}
          onClick={() => setPreviewMode(false)}
        >
          编辑模式
        </button>
        <button 
          className={`control-btn ${previewMode ? 'active' : ''}`}
          onClick={() => setPreviewMode(true)}
        >
          预览模式
        </button>
        <button 
          className="save-btn" 
          onClick={() => alert('已保存到草稿箱')}
        >
          保存草稿
        </button>
        <button 
          className="publish-btn"
          onClick={handleSubmit}
          disabled={isSubmitting}
        >
          {isSubmitting 
            ? (isEditing ? '更新中...' : '发布中...') 
            : (isEditing ? '更新文章' : '发布文章')
          }
        </button>
      </div>
      
      {!previewMode ? (
        <form className="article-form" onSubmit={handleSubmit}>
          <div className="form-section">
            <h3>文章标题</h3>
            <div className="form-hint">
              <span className="hint-item">编辑人：{article.author}</span>
              <span className="hint-item">上次编辑：{formatDate()}</span>
            </div>
            <input
              type="text"
              name="title"
              value={article.title}
              onChange={handleChange}
              placeholder="请输入文章标题"
              className="form-input title-input"
              required
            />
          </div>
          
          <div className="form-section">
            <h3>文章摘要</h3>
            <div className="form-hint">
              <span className="hint-item">编辑人：{article.author}</span>
              <span className="hint-item">建议字数：100-200字</span>
            </div>
            <textarea
              name="excerpt"
              value={article.excerpt}
              onChange={handleChange}
              placeholder="请输入文章摘要，用于在列表页显示"
              className="form-textarea excerpt-textarea"
              rows="3"
              required
            />
          </div>
          
          <div className="form-section">
            <h3>插入文章内容</h3>
            <div className="form-hint">
              <span className="hint-item">请使用Markdown格式输入文章内容</span>
              <span className="hint-item">支持：标题、列表、代码块、链接等</span>
            </div>
            <div className="editor-tools">
              <button type="button" className="tool-btn" onClick={() => handleInsert('标题')}>插入标题</button>
              <button type="button" className="tool-btn" onClick={() => handleInsert('代码块')}>插入代码块</button>
              <button type="button" className="tool-btn" onClick={() => handleInsert('链接')}>插入链接</button>
              <button type="button" className="tool-btn" onClick={() => handleInsert('图片')}>插入图片</button>
              <button type="button" className="tool-btn" onClick={() => handleInsert('列表')}>插入列表</button>
            </div>
            <textarea
              name="content"
              value={article.content}
              onChange={handleChange}
              placeholder="请在此处输入文章内容（支持Markdown语法）..."
              className="form-textarea content-textarea"
              rows="15"
              required
            />
          </div>
          
          <div className="form-section">
            <h3>文章标签</h3>
            <input
              type="text"
              name="tags"
              value={article.tags}
              onChange={handleChange}
              placeholder="请输入标签，用逗号分隔（例如：React,JavaScript,前端）"
              className="form-input tags-input"
            />
          </div>
          
          <div className="form-section">
            <h3>文章信息</h3>
            <div className="info-grid">
              <div className="info-item">
                <label>作者</label>
                <input
                  type="text"
                  name="author"
                  value={article.author}
                  onChange={handleChange}
                  placeholder="pigStar"
                  className="form-input"
                />
              </div>
              <div className="info-item">
                <label>分类</label>
                <select 
                  name="category"
                  value={article.category}
                  onChange={handleChange}
                  className="form-select"
                >
                  <option value="前端">前端</option>
                  <option value="后端">后端</option>
                  <option value="JavaScript">JavaScript</option>
                  <option value="React">React</option>
                  <option value="Node.js">Node.js</option>
                  <option value="TypeScript">TypeScript</option>
                  <option value="其他">其他</option>
                </select>
              </div>
            </div>
          </div>
        </form>
      ) : (
        <div className="article-preview">
          <div className="preview-header">
            <h2>{article.title || '文章标题预览'}</h2>
            <div className="preview-meta">
              <span className="preview-author">作者：{article.author}</span>
              <span className="preview-date">发布日期：{formatDate()}</span>
            </div>
          </div>
          
          <div className="preview-content">
            <div className="preview-excerpt">
              <h4>文章摘要</h4>
              <p>{article.excerpt || '文章摘要预览内容...'}</p>
            </div>
            
            <div className="preview-body">
              <h4>文章内容</h4>
              <div className="markdown-preview">
                {article.content || '文章内容预览...\n\n## 二级标题\n\n这里是文章内容。\n\n```javascript\nconsole.log("Hello World");\n```\n\n- 列表项1\n- 列表项2\n- 列表项3'}
              </div>
            </div>
            
            <div className="preview-tags">
              <h4>文章标签</h4>
              <div className="tags-container">
                {article.tags ? article.tags.split(',').map(tag => tag.trim()).filter(tag => tag).map(tag => (
                  <span key={tag} className="preview-tag">{tag}</span>
                )) : <span className="preview-tag">示例标签</span>}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WriteArticle;